import { ApiService } from '@services/ApiService'
import appStore from '@stores/appStore'
import dashboardStore from '@stores/dashboard'
import { EMAIL_DETAIL_TEMPLATE_TAB } from '@utils/constants'
import {
  OFFSHORE_TEMPLATE_PREVIEW_DENIED_MESSAGE,
  canAccessEmailTemplate,
} from '@utils/offshoreTemplateAccess'
import { Dropdown, Menu, notification } from 'antd'
import cx from 'classnames'
import _ from 'lodash'
import { observer } from 'mobx-react'
import './style.scss'

export type Props = {
  name: string
  disablePreview?: boolean
  fromModuleId?: string
  mvaClaimId?: string
  fromModule?: string
  params?: any
  previewButtonText?: string
  editButtonText?: string
  isShowEditTemplateTab?: boolean
  // modalWidth?: string
  withoutMargin?: boolean
}

const EmailTemplateLink = (props: Props) => {
  const { name, disablePreview } = props

  const isDisabledTemplate = appStore.disabledTemplateKeys.includes(name)

  const openDetailEmailTemplate = () => {
    appStore.hidePreviewEmailTemplate()
    dashboardStore.close('/view/mail-templates')
    setTimeout(() => {
      dashboardStore.open(
        `/view/mail-templates?mode=detail&templateKey=${name}&tab=${EMAIL_DETAIL_TEMPLATE_TAB.Content}`
      )
    })
  }

  const previewTemplate = async () => {
    // A preview renders the template against real case data, so it is gated by the same allowlist
    // as correspondence. Explain the reason rather than just failing — the API rejects it too.
    if (!canAccessEmailTemplate(name)) {
      notification.warning({
        message: 'Template preview not available',
        description: OFFSHORE_TEMPLATE_PREVIEW_DENIED_MESSAGE,
        duration: 8,
      })
      return
    }

    ApiService.EmailTemplate.GetById(name).then(res => {
      appStore.showPreviewEmailTemplate({
        isOpen: true,
        name: props.name,
        fromModule: props.fromModule,
        fromModuleId: props.fromModuleId,
        params: props.params,
        mvaClaimId: props.mvaClaimId,
        data: {
          detail: null,
          preview: null,
        },
        isShowEditTemplateTab:
          props.isShowEditTemplateTab !== false
            ? true
            : props.isShowEditTemplateTab,
      })
    })
  }

  if (appStore.isAdminOrStaff) {
    return (
      <Dropdown
        overlayStyle={{ zIndex: 1000000 }}
        menu={{
          items: [
            {
              key: 'preview',
              label: props.previewButtonText ?? 'Preview Template',
              onClick: e => {
                e.domEvent.stopPropagation()
                previewTemplate()
              },
              disabled: disablePreview,
            },
            ...(props.isShowEditTemplateTab !== false
              ? [
                  {
                    key: 'edit',
                    label: props.editButtonText ?? 'Edit Template',
                    onClick: e => {
                      e.domEvent.stopPropagation()
                      openDetailEmailTemplate()
                    },
                  },
                ]
              : []),
          ],
        }}
      >
        <span
          className={cx([
            'cursor-pointer',
            !props.withoutMargin && 'mr-1',
            'text-blue-400 hover:text-blue-500',
            isDisabledTemplate ? 'line-through' : '',
          ])}
          title={isDisabledTemplate ? 'Template has been disabled' : undefined}
        >
          {name}
        </span>
      </Dropdown>
    )
  } else {
    return <b>{name}</b>
  }
}

export default observer(EmailTemplateLink)
